module.exports = __webpack_public_path__ + "static/media/help_studies_important.b6000547.svg";